import { TableTemplate } from 'types/tableTemplate';

export const procedureTableTemplate: TableTemplate[] = [
  {
    id: 'id',
    description: 'ID',
    originalId: 'id',
    width: 80,
  },
  {
    id: 'name',
    description: 'Consulta',
    originalId: 'name',
    width: 300,
  },
  {
    id: 'formattedSalePrice',
    description: 'Preço de Venda',
    originalId: 'sale_price',
    width: 130,
    dataType: 'number',
  },
  {
    id: 'formattedCommission',
    description: 'Comissão',
    originalId: 'commission',
    width: 130,
    dataType: 'number',
  },
  {
    id: 'formattedActive',
    description: 'Ativo',
    originalId: 'formattedActive',
    width: 200,
  },
];
